import React from 'react'
import ReactPlayer from 'react-player'

interface VideoPlayerProps {
  url: string
  className?: string
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, className = '' }) => {
  return (
    <div
      className={`aspect-video overflow-hidden rounded-2xl bg-gray-1100 ${className}`}
    >
      <ReactPlayer
        url={url}
        width="100%"
        height="100%"
        controls
        muted={true}
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload'
            }
          }
        }}
      />
    </div>
  )
}

export default VideoPlayer
